// Collection page: disable swatch clicks on product cards (variant updates handled by morak-model-cards.js)
(function () {
  const isCollectionLike = location.pathname.startsWith("/collections/") || document.querySelector("results-list");
  if (!isCollectionLike) return;

  function disableSwatchClicks(root = document) {
    const swatches = root.querySelectorAll(
      "product-card product-swatches, .product-card product-swatches, product-swatches"
    );

    swatches.forEach((ps) => {
      if (ps.dataset.morakNoClick === "1") return;
      ps.dataset.morakNoClick = "1";

      ps.addEventListener(
        "click",
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          ev.stopImmediatePropagation();
        },
        true
      );

      ps.querySelectorAll("a,button,input,label").forEach((el) => {
        el.setAttribute("tabindex", "-1");
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => disableSwatchClicks());
  document.addEventListener("shopify:section:load", (e) => disableSwatchClicks(e.target));
  document.addEventListener("shopify:section:reorder", () => disableSwatchClicks());
})();

(function () {
  const HAS_HOVER = window.matchMedia("(hover: hover) and (pointer: fine)");
  const isCollectionLike = location.pathname.startsWith("/collections/") || document.querySelector("results-list");
  if (!isCollectionLike) return;

  function getSwatchTarget(el) {
    return el.closest(
      "product-swatches a, product-swatches button, product-swatches label, product-swatches input, product-swatches [data-swatch], product-swatches li"
    );
  }

  function triggerPreview(target) {
    target.dispatchEvent(new MouseEvent("mouseover", { bubbles: true, cancelable: true }));
    target.dispatchEvent(new MouseEvent("mouseenter", { bubbles: true, cancelable: true }));
    target.dispatchEvent(new PointerEvent("pointerenter", { bubbles: true, cancelable: true }));
    target.dispatchEvent(new Event("focus", { bubbles: true, cancelable: true }));

    const input = target.matches("input") ? target : target.querySelector?.("input");
    if (input) {
      if (input.type === "radio" || input.type === "checkbox") input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function setActive(card, target) {
    card.querySelectorAll("[data-morak-swatch-active='1']").forEach((n) => {
      n.dataset.morakSwatchActive = "0";
      n.removeAttribute("aria-pressed");
    });

    target.dataset.morakSwatchActive = "1";
    target.setAttribute("aria-pressed", "true");
  }

  document.addEventListener(
    "click",
    (ev) => {
      if (HAS_HOVER.matches) return;

      const card = ev.target.closest("product-card, .product-card");
      if (!card) return;

      const swatch = getSwatchTarget(ev.target);
      if (!swatch) return;

      ev.preventDefault();
      ev.stopPropagation();
      ev.stopImmediatePropagation();

      setActive(card, swatch);
      triggerPreview(swatch);
    },
    true
  );
})();
